import React, { SVGProps } from 'react';

function UserGroup(props: SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5.42157 4.98651C6.17172 4.23637 7.18913 3.81494 8.25 3.81494C9.31087 3.81494 10.3283 4.23637 11.0784 4.98651C11.8286 5.73666 12.25 6.75408 12.25 7.81494C12.25 8.87581 11.8286 9.89322 11.0784 10.6434C10.3283 11.3935 9.31087 11.8149 8.25 11.8149C7.18913 11.8149 6.17172 11.3935 5.42157 10.6434C4.67143 9.89322 4.25 8.87581 4.25 7.81494C4.25 6.75408 4.67143 5.73666 5.42157 4.98651Z"
        fill={fill}
      />
      <path
        clipRule="evenodd"
        d="M3.87478 14.4998C5.03516 13.3394 6.60897 12.6875 8.25 12.6875C9.89103 12.6875 11.4648 13.3394 12.6252 14.4998C13.7856 15.6602 14.4375 17.234 14.4375 18.875C14.4375 19.0242 14.3782 19.1673 14.2727 19.2727C14.1673 19.3782 14.0242 19.4375 13.875 19.4375H2.625C2.47582 19.4375 2.33274 19.3782 2.22725 19.2727C2.12176 19.1673 2.0625 19.0242 2.0625 18.875C2.0625 17.234 2.7144 15.6602 3.87478 14.4998Z"
        fill={fill}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.386 7.30101C15.0189 6.66808 15.8774 6.3125 16.7725 6.3125C17.6676 6.3125 18.526 6.66808 19.1589 7.30101C19.7919 7.93395 20.1475 8.79239 20.1475 9.6875C20.1475 10.5826 19.7919 11.4411 19.1589 12.074C18.526 12.7069 17.6676 13.0625 16.7725 13.0625C15.8774 13.0625 15.0189 12.7069 14.386 12.074C13.753 11.4411 13.3975 10.5826 13.3975 9.6875C13.3975 8.79239 13.753 7.93395 14.386 7.30101Z"
        fill={fill}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M15.1705 14.0288C15.9514 13.741 16.7903 13.646 17.6158 13.7521C18.4413 13.8581 19.2289 14.1619 19.9118 14.6377C20.5946 15.1135 21.1524 15.7472 21.5378 16.4848C21.9231 17.2225 22.1246 18.0424 22.1251 18.8746C22.1251 19.0238 22.0659 19.167 21.9604 19.2726C21.8549 19.3781 21.7118 19.4374 21.5626 19.4374L16.8022 19.4371C16.4916 19.4371 16.2397 19.1853 16.2397 18.8746C16.2397 16.8114 15.4319 15.6333 14.9042 14.8791C14.8042 14.7361 14.7761 14.5549 14.8283 14.3884C14.8804 14.222 15.0069 14.0891 15.1705 14.0288Z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  );
}

UserGroup.displayName = 'UserGroupSolid';

export default UserGroup;
